import React, {useEffect} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

// Extend Window interface to include grecaptcha
declare global {
  interface Window {
    grecaptcha: any;
  }
}

interface ReCaptchaProviderProps {
  children: React.ReactNode;
}

const ReCaptchaProvider: React.FC<ReCaptchaProviderProps> = ({children}) => {
  useEffect(() => {
    // Load reCAPTCHA script if not already loaded
    if (!window.grecaptcha && process.env.REACT_APP_RECAPTCHA_KEY) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <>
      {children}
      {process.env.REACT_APP_RECAPTCHA_KEY && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
          size="invisible"
          style={{display: 'none'}}
        />
      )}
    </>
  );
};

export default ReCaptchaProvider;
